// Logo hãng bay cho gói Tiếp viên hàng không, khoá theo mã mục đích mà server
// trả về (PublicCustomerBookingPurpose.id). Cùng cách làm với ảnh cơ sở ở
// branches.ts: dữ liệu do server quyết, ảnh là chuyện trưng bày của giao diện.
//
// Nguồn ảnh: trang chính thức của từng hãng, tải 20/08/2026. Đã chuẩn hoá về
// cao 48px, nền trong suốt. Hãng không có trong bảng thì chỉ hiện tên — KHÔNG
// dựng logo thay thế, tránh gắn nhầm nhận diện của hãng khác.
const PURPOSE_LOGOS: Record<string, string> = {
  vn_airline: "/images/airlines/vn_airline.png",
  vietjet: "/images/airlines/vietjet.png",
  bamboo_airway: "/images/airlines/bamboo_airway.png",
  vietravel_airway: "/images/airlines/vietravel_airway.png",
};

export function purposeLogo(purposeId: string): string | undefined {
  return PURPOSE_LOGOS[purposeId];
}
